import { render, staticRenderFns } from "./Dispatch.vue?vue&type=template&id=d6bc9ea6&scoped=true"
import script from "./Dispatch.vue?vue&type=script&lang=js"
export * from "./Dispatch.vue?vue&type=script&lang=js"
import style0 from "./Dispatch.vue?vue&type=style&index=0&id=d6bc9ea6&prod&lang=scss&scoped=true"
import style1 from "./Dispatch.vue?vue&type=style&index=1&id=d6bc9ea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bc9ea6",
  null
  
)

export default component.exports